import React, { useState, useEffect } from "react";

import { Formik } from "formik";

import providerManagerDashboardApi from "apis/providerManagerDashboard";
import providerManagerEntitiesApi from "apis/providerManagerEntity";
import { PageLoader } from "clearsense-ui/components";

import EditForm from "./EditForm";

import { EDIT_FORM_VALIDATION_SCHEMA } from "../validations";

const Edit = ({
  data,
  currentEntityID,
  currentEntityItemID,
  npiRecords,
  searchParams,
  isViewMode,
  userPermissions,
  updateData,
  handleSearch,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [currentTemplate, setCurrentTemplate] = useState();

  const fetchTemplate = async () => {
    setIsLoading(true);
    try {
      const { data } = await providerManagerEntitiesApi.fetchTemplate(
        currentEntityID
      );
      setCurrentTemplate(data.template);
    } catch (err) {
      logger.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplate();
  }, [currentEntityID]);

  const handleSave = async values => {
    try {
      npiRecords.length
        ? await providerManagerDashboardApi.update(
            searchParams.provider_manager_dashboard.npi,
            {
              provider_manager_template_id: currentTemplate.id,
              value: JSON.stringify(values),
            }
          )
        : await providerManagerDashboardApi.create({
            entity_key: searchParams.provider_manager_dashboard.npi,
            provider_manager_template_id: currentTemplate.id,
            value: JSON.stringify(values),
          });
      await handleSearch({ npi: searchParams.provider_manager_dashboard.npi });
      currentEntityItemID &&
        updateData({
          ...searchParams.provider_manager_dashboard,
          entity_id: currentEntityID,
          entity_item_id: currentEntityItemID,
        });
    } catch (err) {
      logger.log(err);
    }
  };

  if (isLoading) return <PageLoader />;

  return (
    <Formik
      validateOnChange
      initialValues={{
        ...currentTemplate?.template?.hierarchies?.reduce(
          (acc, curr) => ({ ...acc, [curr?.name]: [] }),
          {}
        ),
        ...(data
          ? JSON.parse(JSON.stringify(data)?.replaceAll("null", '""'))
          : []),
      }}
      validationSchema={EDIT_FORM_VALIDATION_SCHEMA}
      onSubmit={handleSave}
    >
      <EditForm
        data={
          data ||
          currentTemplate?.template?.hierarchies?.reduce(
            (acc, curr) => ({ ...acc, [curr?.name]: [] }),
            {}
          )
        }
        currentEntityID={currentEntityID}
        npiRecords={npiRecords}
        isViewMode={isViewMode}
        userPermissions={userPermissions}
        currentTemplate={currentTemplate}
      />
    </Formik>
  );
};

export default Edit;
